<template>
  <div class="container-fluid">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>Send Invoice</h3>
        <hr />
        <el-form
          class="form"
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item class="form-item" label="Contact">
            <el-autocomplete
              style="width: 100%"
              id="customer-contact"
              class="inline-input"
              v-model="form.contact"
              :fetch-suggestions="contactSearch"
              placeholder="Search contact"
              prefix-icon="el-icon-search"
              @select="contactSelected"
            ></el-autocomplete>
          </el-form-item>
          <!-- {{form.contact}} -->
          <!-- <el-form-item class="form-item" label="Package">
            <el-select
              style="width: 100%"
              v-model="form.package"
              placeholder="Package"
              @change="packageSelected"
            >
              <el-option
                v-for="(item,index) in systemTypes"
                :key="`${item.id}_package_${index}`"
                :label="item.name"
                :value="item.id"
                style="height: 55px;"
              >
                <h4 style="float: left; margin: 0px;">{{ item.name }}</h4>
                <span
                  style="float: left; color: #8492a6; font-size: 13px; line-height: 20px;"
                >{{ item.description }}</span>
              </el-option>
            </el-select>
          </el-form-item>-->

          <el-form-item class="form-item" label="Installation">
            <!-- {{JSON.stringify(installationOptionsTest)}} -->
            <el-select
              v-model="form.installation"
              placeholder="Select installation"
              style="width: 100%"
              @change="installationSelected"
            >
              <el-option
                v-for="item in installationOptionsTest"
                :key="`${item.CID ? item.CID : item.solarKitIds}_item_list`"
                :label="`${item.label}`"
                :value="item"
              ></el-option>

              <!-- <el-option
                v-for="item in installationOptions"
                :key="`${item.CID?item.CID:item.solarKitIds}_item_list`"
                :label="`${item.CID?item.CID:item.solarKitIds} - ${item.name} (${item.deviceType.name})`"
                :value="item"
              ></el-option>-->
            </el-select>
          </el-form-item>

          <el-form-item class="form-item" label="Billing Period">
            <el-date-picker
              v-model="form.period"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>

          <el-form-item class="form-item" label="Amount (₦)">
            <el-input-number
              style="width: 100%"
              id="customer-price"
              v-model="form.amount"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item class="form-item" label=" VAT (%)">
            <el-select
              v-model="form.orderVat"
              placeholder="Select"
              style="width: 100px"
            >
              <el-option
                :key="`0_item_vat_list`"
                :label="`0%`"
                :value="0.0"
              ></el-option>
              <el-option
                :key="`7_5_item_vat_list`"
                :label="`7.5%`"
                :value="7.5"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item class="form-item" label="Discount">
            <el-select v-model="discountType" placeholder="Discount type" style="width: 140px">
              <el-option :key="`discount_item_list_percent`" label="Percent (%)" value="percent"></el-option>
              <el-option :key="`discount_item_list_cash`" label="Amount (₦)" value="amount"></el-option>
            </el-select>
            <el-select
              v-if="discountType == `percent`"
              v-model="form.orderDiscount"
              placeholder="Select"
              style="width: 100px"
            >
              <el-option
                v-for="item in 101"
                :key="`${item}_item_list`"
                :label="item - 1"
                :value="item - 1"
              ></el-option>
            </el-select>
            <el-input-number
              v-else
              style="width: 180px"
              id="customer-price"
              v-model="form.amountDiscount"
              :min="1"
            ></el-input-number>
          </el-form-item>-->

          <el-form-item class="fo​​rm-item" label="Description">
            <el-input
              type="textarea"
              :autosize="{ minRows: 8, maxRows: 12 }"
              placeholder="Please input"
              v-model="form.comment"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item class="fo​​rm-item" label="Terms">
            <el-input
              type="textarea"
              :autosize="{ minRows: 8, maxRows: 12}"
              placeholder="Please input"
              v-model="regDataParams.deviceRequest.term"
            ></el-input>
          </el-form-item>-->
          <el-form-item>
            <el-button
              type="prim​​ary"
              class="customer-btn"
              :disabled="isSending"
              @click="onSubmit()"
              >{{ isSending ? "Sending..." : "Send Invoice" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </vk-offcanvas>

    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px"
      >
        <h2 style="flex: 1">Invoices</h2>
        <can I="create" a="installation">
          <span style="display: flex; align-items: center">
            <button class="btn btn-primary" @click="showOffCanvas = true">
              New Invoice
            </button>
          </span>
        </can>

        <can I="create" a="installation">
          <span style="display: flex; align-items: center; margin:10px">
            <button
              class="btn btn-primary"
              @click="DispatchInvoice"
              :disabled="isDispatching"
            >
              {{ isDispatching ? "Sending..." : "Send Reminder" }}
            </button>
          </span>
        </can>
      </div>

      <div>
        <Invoices ref="invoiceComponent"></Invoices>
      </div>
    </div>
  </div>
</template>

<script>
import Invoices from "./invoices";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
export default {
  name: "",
  components: {
    Invoices,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      errors: [],
      installationOptions: [],
      installationOptionsTest: [],
      showOffCanvas: false,
      isSending: false,
      isDispatching: false,
      contactList: [],
      form: {
        user: null,
        invoiceType: "subscription",
        orderVat: 0,
        contact: null,
        amount: null,
        installation: null,
        comment: null,
        period: null
      }
    };
  },
  computed: {},
  methods: {
    validate() {
      var err = [];
      for (let [field, value] of Object.entries(this.form)) {
        // console.log(`${field}: ${value}`);
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "user":
            if (value === "null" || value === "") {
              err[field] = "Select a user.";
            }
            break;
          case "invoiceType":
            if (value === "null" || value === "") {
              err[field] = "Choose invoice type.";
            }
            break;
          case "installation":
            if (value === "null" || value === "") {
              err[field] = "Select an installation.";
            }
            break;
          case "amount":
            if (value === "null" || value === "") {
              err[field] = "Amount cannot be empty.";
            }
            break;
          case "comment":
            if (value === "null" || value === "") {
              err[field] = "Description can not be empty.";
            }
            break;
          case "period":
            if (value === "null" || value === "") {
              err[field] = "Select billing period.";
            }
            break;
          default:
            break;
        }
      }
      this.errors = err;
      //   console.log(this.errors);
    },
    onSubmit() {
      try {
        const HTTP = this.$httpUtils.instance;
        let container = this;
        this.validate();
        var errorLength = Object.keys(this.errors).length;
        //   console.log(errorLength);
        if (errorLength > 0) {
          this.errorMessage = Object.values(this.errors).join("<br>");
          this.displayError = true;
          setTimeout(() => {
            this.displayError = false;
          }, 3000);
          this.showErrorMsg({
            message: this.errorMessage
          });
        } else {
          // console.log({ reqPayload: this.form.installation });
          // return;
          let reqPayload = {
            payload: this.form,
            userId: this.form.user.id,
            type: this.form.invoiceType,
            paymentMode: this.form.installation.deviceRequest.paymentModel
          };

          // return;
          let url = `/invoices`;
          this.isSending = true;
          HTTP.post(url, reqPayload)
            .then(response => {
              this.isSending = false;
              container.showOffCanvas = false;
              container.showSuccessMsg({
                message: "Invoice Sent!"
              });
              setTimeout(() => {
                // window.location.reload();
              }, 1000);
            })
            .catch(error => {
              this.isSending = false;
              container.showErrorMsg({
                message: JSON.stringify(
                  error.response.data.error.details.messages
                )
              });
            });
        }
      } catch (error) {
        console.log({ error });
      }
    },
    installationSelected(installation) {
      let modelMap = {
        OS: "OUTRIGHT",
        ES: "ENERGY AS A SERVICE",
        LO: "LEASE TO OWN"
      };
      // console.log({ installation, deviceRequest: installation.deviceRequest });
      // let ctx = this;
      // ctx.form.installation = installation;
      //   console.log(installation.deviceRequest.paymentModel,modelMap[installation.deviceRequest.paymentModel]);
      this.form["comment"] = `${modelMap[
        installation &&
          installation.deviceRequest &&
          installation.deviceRequest.paymentModel
      ] || "OUTRIGHT"}`;
    },
    contactSearch(queryString, cb) {
      let contacts = this.contactList;
      var results = queryString
        ? contacts.filter(contact => this.createFilter(queryString, contact))
        : contacts;
      cb(results);
    },
    createFilter(queryString, contact) {
      return (
        `${contact.First_Name} ${contact.Last_Name}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSelected(contact) {
      console.log({ contact });
      this.form.user = contact;
      this.form.installation = null;
      console.log({ installation: contact.installations });
      if (contact.installations && contact.installations.length > 0) {
        console.log({ installationIn: contact.installations });
        // this.installationOptions = contact.installations;
        this.installationOptionsTest = contact.installations.map(x => ({
          ...x,
          value: x,
          label: `${x.CID ? x.CID : x.solarKitIds} - ${x.name} (${
            x.deviceType.name
          })`
        }));
        console.log({ installationOptions: this.installationOptions });
      }
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      let container = this;
      let filter = {
        include: { installations: ["deviceRequest", "deviceType"] },
        roleType: "customer"
      };
      const url = `/users?filter=${JSON.stringify(filter)}`;
      HTTP.get(url)
        .then(response => {
          container.contactList = response.data.map(x => ({
            ...x,
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: `${x.firstName} ${x.lastName}`
          }));
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    submitInvoice() {
      //  let url = `/invoices?filter=${JSON.stringify(filter)}`;
    },
    DispatchInvoice() {
      const HTTP = this.$httpUtils.instance;
      const data = this.$refs.invoiceComponent.selectedRow;
      let container = this;
      if (!data) return;
      try {
        let reqPayload = {
          invoiceIDs: data
        };
        let url = `invoices/bulk-invoice-reminder`;
        this.isDispatching = true;
        HTTP.post(url, reqPayload).then(response => {
          this.isDispatching = false;
          container.showSuccessMsg({
            message: "Invoice Sent!"
          });
          setTimeout(() => {
            // window.location.reload();
          }, 1000);
        });
      } catch (error) {
        this.isDispatching = false;
        container.showErrorMsg({
          message: JSON.stringify(error.response.data.error.message)
        });
      }
    }
  },
  async mounted() {
    this.fetchUsers();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/invoices/index.vue